// extracted by mini-css-extract-plugin
module.exports = {"titleTotal":"_1301553","titleBalances":"_a5fb641","balance":"_d554d25","balances":"_d8eb90c","currency":"_7f5c125"};